import React, { useEffect, useState } from "react";
import { getRequests, getBesRequests } from "../../apis/requests";
import { useLocation, useNavigate } from "react-router";
import Popup from "../../ReusableFunctions/Popup";
import Loading from "../../ReusableFunctions/Loader";
import MainContentWrapper from "../../Components/MainContentWrapper";
import RequestOverView from "./SubComponents/RequestOverView/RequestOverView";
import calender from "../../assets/calender-new.svg";
import calenderActive from "../../assets/calender-active.svg";
import lines from "../../assets/lines.png";
import lineActive from "../../assets/lineActive.png";
import CalenderComponent from "./Calender/CalenderComponent";
import RequestTable from "./SubComponents/RequestTable/RequestTable";
import BesRequestTable from "./SubComponents/RequestTable/SubComponents/BesRequestTable";
import CalenderViewRequestTable from "./SubComponents/CalenderViewRequestTable/CalenderViewRequestTable";
import { toDate } from "date-fns";
import { Button } from "../../Components/Helper";
import CreateRequest from "./CreateRequest";
import ViewPilotHistoryOnMap from "./SubComponents/MapViewPilotLocation/ViewPilotHistoryOnMap";
import { getPilotLocationsHistoryDSP } from "../../apis/dronePilots";
import { getServices } from "../../apis/services";
import { clearProfileFilters } from "../../ReusableFunctions/reusableFunctions";
import { STATUS } from "../../appConstants";

export const ChipInputOptions = [
  { id: 1, label: "All", onclick: () => {} },
  { id: 2, label: "Placed", onclick: () => {} },
  { id: 3, label: "Scheduled", onclick: () => {} },
  { id: 4, label: "Ongoing", onclick: () => {} },
  { id: 7, label: "Completed", onclick: () => {} },
  { id: 5, label: "Paid", onclick: () => {} },
  { id: 6, label: "Cancelled", onclick: () => {} },
];

const MyRequests = () => {
  const { state } = useLocation();
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(search);
  const requestPerPage = 15;
  const [requests, setRequests] = useState([]);
  const [besRequests, setBesRequests] = useState([]);
  const [isSparyingRequestAvailable, setisSparyingRequestAvailable] =
    useState(false);
  const [isCalenderView, setIsCalenderView] = useState(() => {
    const savedFilters = localStorage.getItem("isCalenderView");
    if (savedFilters) {
      const view = JSON.parse(savedFilters);
      return view;
    }
    return state?.isCalenderView || params?.get("isCalenderView");
  });

  const [activeTab, setActiveTab] = useState("ALL");

  const [pilotId, setPilotId] = useState(
    state?.pilotId || params?.get("pilotId"),
  );
  const [pilotName, setPilotName] = useState(
    state?.pilotName || params?.get("pilotName"),
  );
  const [isGraphView, setIsGraphView] = useState(() => {
    const savedFilters = localStorage.getItem("isCalenderView");
    if (savedFilters) {
      const view = JSON.parse(savedFilters);
      return !view;
    }
    return !(state?.isCalenderView || params?.get("isCalenderView"));
  });
  const [selectedDate, setSelectedDate] = useState(() => {
    const savedSelectedDate = localStorage.getItem("currentCalenderDate");
    if (savedSelectedDate) {
      const date = JSON.parse(savedSelectedDate);
      return new Date(date);
    }
    return new Date();
  });
  const [loading, setLoading] = useState(true);
  const [filetrs, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem("requestFilters");
    if (savedFilters) {
      const parsedFilters = JSON.parse(savedFilters);
      return {
        ...parsedFilters,
        statuses: parsedFilters.statuses,
        locations: parsedFilters.locations,
        services: parsedFilters.services,
      };
    }
    return {
      services: [],
      statuses: [
        STATUS.PLACED,
        STATUS.ACCEPTED,
        STATUS.RESCHEDULED,
        STATUS.HOLD,
      ],
      locations: [],
      orderBy: "time", // Default orderBy for "Scheduled"
      orderType: "ASC", // Default orderType for "Scheduled"
    };
  });

  const [besFiletrs, setBesFilters] = useState(() => {
    const savedFilters = localStorage.getItem("besRequestFilters");
    if (savedFilters) {
      const parsedFilters = JSON.parse(savedFilters);
      return {
        ...parsedFilters,
        statuses: parsedFilters.statuses,
        locations: parsedFilters.locations,
        services: parsedFilters.services,
      };
    }
    return {
      services: [],
      statuses: [STATUS.PLACED],
      locations: [],
      orderBy: "date_created",
      orderType: "DESC",
    };
  });

  const [pageNumber, setpageNumber] = useState(() => {
    const savedPage = localStorage.getItem("currentRequestPage");
    if (savedPage) {
      return parseInt(savedPage);
    }
    return 1;
  });

  const [besPageNumber, setBesPageNumber] = useState(() => {
    const savedPage = localStorage.getItem("currentBesRequestPage");
    if (savedPage) {
      return parseInt(savedPage);
    }
    return 1;
  });

  const [filterDateTime, setFilterDateTime] = useState(() => {
    const savedFilterDateTime = localStorage.getItem("filterDateTime");
    if (savedFilterDateTime) {
      try {
        return JSON.parse(savedFilterDateTime);
      } catch {
        console.warn("Error parsing filterDateTime from localStorage");
        return { fromDate: undefined, toDate: undefined };
      }
    }
    return { fromDate: undefined, toDate: undefined };
  });

  const [searchString, setSearchString] = useState(
    "",
    // ()=>{
    // const savedSearchString = localStorage.getItem("SearchQuery");
    // if (savedSearchString) {
    //   return JSON.parse(savedSearchString);
    // }
    // return "";}
  );

  const [besSearchString, setBesSearchString] = useState("");

  const [openCreateRequestPopup, setOpenCreateRequestPopup] = useState(false);
  const [pilotLocations, setpilotLocations] = useState([]);
  const [statusType, setStatusType] = useState(() => {
    let savedStatus = localStorage.getItem("request_filters_status");
    if (savedStatus) {
      savedStatus = JSON.parse(savedStatus);
      return savedStatus;
    }
    return ChipInputOptions[2]?.label;
  });

  const [besStatusType, setBesStatusType] = useState("Placed");

  const getRequestsAPI = async (
    pageSize,
    pageNumber,
    statusType,
    filters,
    searchQuery,
    fromDate,
    toDate,
  ) => {
    try {
      setLoading(true);
      const data = await getRequests(
        state?.userId,
        filters,
        pageSize,
        pageNumber,
        statusType,
        searchQuery,
        fromDate,
        toDate,
      );
      setRequests(data.requests);
      setLoading(false);
    } catch (err) {
      console.log("errr:", err);
      setLoading(false);
      Popup.alert("Error", err, "ERROR");
    }
  };

  const getBesRequestsAPI = async (
    pageSize,
    besPageNumber,
    statusType,
    filters,
    searchQuery,
    fromDate,
    toDate,
  ) => {
    try {
      setLoading(true);
      const data = await getBesRequests(
        state?.userId,
        filters,
        pageSize,
        besPageNumber,
        statusType,
        searchQuery,
        fromDate,
        toDate,
      );
      setBesRequests(data.requests);
      setLoading(false);
    } catch (err) {
      console.log("errr:", err);
      setLoading(false);
      Popup.alert("Error", err, "ERROR");
    }
  };

  const getRequest = async () => {
    Loading.set(true);
    setLoading(true);
    if (isCalenderView) {
      await getRequestsAPI(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        selectedDate
          ? new Date(new Date(selectedDate).setHours(0, 0, 0)).toISOString()
          : undefined,
        selectedDate
          ? new Date(new Date(selectedDate).setHours(23, 59, 999)).toISOString()
          : undefined,
      );
    } else {
      await getRequestsAPI(
        requestPerPage,
        pageNumber,
        statusType,
        filetrs,
        undefined,
        filterDateTime && filterDateTime.fromDate
          ? new Date(filterDateTime.fromDate).toISOString()
          : undefined,
        filterDateTime && filterDateTime.toDate
          ? new Date(filterDateTime.toDate).toISOString()
          : undefined,
      );
    }
    Loading.set(false);
    setLoading(false);
  };

  const getBESRequest = async () => {
    Loading.set(true);
    setLoading(true);
    await getBesRequestsAPI(
      requestPerPage,
      besPageNumber,
      besStatusType,
      besFiletrs,
      undefined,
      filterDateTime && filterDateTime.fromDate
        ? new Date(filterDateTime.fromDate).toISOString()
        : undefined,
      filterDateTime && filterDateTime.toDate
        ? new Date(filterDateTime.toDate).toISOString()
        : undefined,
    );

    Loading.set(false);
    setLoading(false);
  };

  // useEffect(() => {
  //   if(activeTab === "BES") {
  //     getBESRequests();
  //   } else {
  //     getRequest();
  //   }
  // }, [activeTab]);

  const getPilotLocationsHistory = async () => {
    try {
      setLoading(true);
      let pilotsLocations = await getPilotLocationsHistoryDSP(
        pilotId,
        selectedDate
          ? new Date(new Date(selectedDate).setHours(0, 0, 0, 0)).toISOString()
          : new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
        selectedDate
          ? new Date(
              new Date(selectedDate).setHours(23, 59, 59, 999),
            ).toISOString()
          : new Date(new Date().setHours(23, 59, 59, 999)).toISOString(),
      );
      setpilotLocations(pilotsLocations);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Popup.alert("Error", err, "ERROR");
    }
  };

  useEffect(() => {
    document.title = "BhuMeet - My Requests";
    clearProfileFilters();
    if (!pilotId && !isCalenderView) {
      if (activeTab === "ALL") {
        getRequest();
      } else if (activeTab === "BES") {
        getBESRequest();
      }
    }
    if (isCalenderView && pilotId) {
      getPilotLocationsHistory();
    }
  }, [
    state?.userId,
    isGraphView,
    isCalenderView,
    pilotId,
    selectedDate,
    activeTab,
  ]);

  useEffect(() => {
    setSearchString("");
    setBesSearchString("");
  }, [activeTab]);

  const filterChanged = async () => {
    try {
      setLoading(true);
      if (activeTab === "ALL") {
        console.log("searchString", searchString);
        await getRequestsAPI(
          requestPerPage,
          pageNumber,
          statusType,
          filetrs,
          searchString,
          filterDateTime && filterDateTime.fromDate
            ? new Date(filterDateTime.fromDate).toISOString()
            : undefined,
          filterDateTime && filterDateTime.toDate
            ? new Date(filterDateTime.toDate).toISOString()
            : undefined,
        );
      } else {
        await getBesRequestsAPI(
          requestPerPage,
          besPageNumber,
          besStatusType,
          besFiletrs,
          besSearchString,
          filterDateTime && filterDateTime.fromDate
            ? new Date(filterDateTime.fromDate).toISOString()
            : undefined,
          filterDateTime && filterDateTime.toDate
            ? new Date(filterDateTime.toDate).toISOString()
            : undefined,
        );
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      Popup.alert("Error", e, "ERROR");
    }
  };

  useEffect(() => {
    getServicesFunc();
  }, []);

  const getServicesFunc = async () => {
    try {
      let services = await getServices();
      // Check if no service has service_type as "sparying"
      const hasSparyingService = services.some(
        (service) => service.service_type === "Spraying service",
      );
      // Set the state based on whether sparying service is available
      setisSparyingRequestAvailable(hasSparyingService);
    } catch (err) {
      console.error("Error fetching services:", err);
    }
  };

  useEffect(() => {
    if (isGraphView) {
      filterChanged();
    }
    localStorage.setItem("requestFilters", JSON.stringify(filetrs));
    localStorage.setItem("besRequestFilters", JSON.stringify(besFiletrs));
    localStorage.setItem("currentRequestPage", JSON.stringify(pageNumber));
    localStorage.setItem(
      "currentBesRequestPage",
      JSON.stringify(besPageNumber),
    );
    localStorage.setItem("filterDateTime", JSON.stringify(filterDateTime));
    localStorage.setItem("SearchQuery", JSON.stringify(searchString));
    // localStorage.setItem("BesSearchQuery", JSON.stringify(besSearchString));
    localStorage.setItem("isCalenderView", JSON.stringify(isCalenderView));
    localStorage.setItem("request_filters_status", JSON.stringify(statusType));
  }, [
    filetrs,
    besFiletrs,
    pageNumber,
    besPageNumber,
    filterDateTime?.fromDate,
    filterDateTime?.toDate,
    searchString,
    besSearchString,
    isCalenderView,
    statusType,
  ]);

  return (
    <>
      <MainContentWrapper
        header={pilotId ? "" : "My Orders"}
        rightContent={
          pilotId ? (
            <></>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <Button
                style={{ height: "33px", fontSize: "14px" }}
                text={"Create Request"}
                onClick={() => {
                  setOpenCreateRequestPopup(true);
                }}
              />
              <div
                style={{
                  display: "flex",
                  gap: "",
                  alignItems: "center",
                  border: "1px solid rgb(132 132 132 / 39%)",
                  borderRadius: "3px",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    background: isGraphView ? "" : "rgba(15, 94, 255, 0.1)",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={isCalenderView ? calenderActive : calender}
                    alt="calender icon"
                    style={{ width: "16px", cursor: "pointer" }}
                    onClick={() => {
                      if (!isCalenderView) {
                        setIsCalenderView(true);
                        setRequests([]);
                        setIsGraphView(false);
                      }
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "1px",
                    background: "rgb(132 132 132 / 39%)",
                    height: "100%",
                  }}
                ></div>
                <div
                  style={{
                    background: isCalenderView ? "" : "rgba(15, 94, 255, 0.1)",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    width: "30px",
                    justifyContent: "center",
                    height: "30px",
                  }}
                >
                  {isCalenderView ? (
                    <div style={{ margin: 0, padding: 0 }}>
                      <img
                        src={isGraphView ? lineActive : lines}
                        alt="lines icon"
                        style={{ width: "18px", cursor: "pointer" }}
                        onClick={() => {
                          setIsGraphView(true);
                          setIsCalenderView(false);
                        }}
                      />
                    </div>
                  ) : (
                    <img
                      src={isGraphView ? lineActive : lines}
                      alt="lines icon"
                      style={{ width: "18px", cursor: "pointer", padding: "" }}
                      onClick={() => {
                        setIsGraphView(true);
                        setIsCalenderView(false);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          )
        }
      >
        {openCreateRequestPopup && isSparyingRequestAvailable ? (
          <CreateRequest
            onClose={() => {
              setOpenCreateRequestPopup(false);
              getRequest();
              setActiveTab("ALL");
            }}
          />
        ) : openCreateRequestPopup && !isSparyingRequestAvailable ? (
          Popup.alert(
            "WARNING",
            "First create the sparying service , then place request!",
            "SUCCESS",
            () => {
              setOpenCreateRequestPopup(false);
            },
            null,
            "Ok",
            null,
          )
        ) : null}
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            height: "93%",
            display: "flex",
            flexDirection: isGraphView ? "column" : "row",
            gap: "20px",
          }}
        >
          {state?.userId ? (
            ""
          ) : isGraphView ? (
            <RequestOverView />
          ) : (
            <div
              style={{
                width: "50%",
                display: "flex",
                flexDirection: "column",
                gap: "35px",
              }}
            >
              <div style={{ width: "100%", height: "max-content" }}>
                <CalenderComponent
                  user={{ ...state, pilotId, pilotName, isCalenderView: true }}
                  date={selectedDate}
                  onDateChange={(req, date, requestCount) => {
                    setRequests(req);
                    localStorage.setItem(
                      "currentCalenderDate",
                      JSON.stringify(date),
                    );
                    setSelectedDate(date);
                  }}
                />
              </div>
              {isCalenderView && pilotId && (
                <ViewPilotHistoryOnMap pilotLocations={pilotLocations} />
              )}
            </div>
          )}

          <div
            style={{
              height: isGraphView ? "calc(100% - 390px)" : "100%",
              width: isGraphView ? "100%" : "50%",
            }}
          >
            {isGraphView ? (
              activeTab === "ALL" ? (
                <RequestTable
                  pageNumber={pageNumber}
                  requests={requests}
                  dateTime={filterDateTime}
                  statusType={statusType}
                  filters={filetrs}
                  onFilterChange={(filters, dateTime) => {
                    setFilters(filters);
                    if (dateTime) {
                      setFilterDateTime(dateTime);
                    }
                    setpageNumber(1);
                  }}
                  onStatusFilterChanged={(status) => {
                    let updatedStatus = [];
                    let orderBy = "date_created";
                    let orderByType = "DESC";
                    switch (status) {
                      case ChipInputOptions[1]?.label:
                        updatedStatus = [STATUS.PLACED];
                        break;
                      case ChipInputOptions[2]?.label:
                        updatedStatus = [
                          STATUS.PLACED,
                          STATUS.ACCEPTED,
                          STATUS.RESCHEDULED,
                          STATUS.HOLD,
                        ];
                        orderBy = "time";
                        orderByType = "ASC";
                        break;
                      case ChipInputOptions[3]?.label:
                        updatedStatus = [
                          STATUS.OUT_FOR_SERVICE,
                          STATUS.INPROGRESS,
                        ];
                        orderBy = "last_updated";
                        orderByType = "DESC";
                        break;
                      case ChipInputOptions[4]?.label:
                        updatedStatus = [STATUS.COMPLETED];
                        orderBy = "last_updated";
                        orderByType = "DESC";
                        break;
                      case ChipInputOptions[5]?.label:
                        updatedStatus = [STATUS.PAID];
                        orderBy = "last_updated";
                        orderByType = "DESC";
                        break;
                      case ChipInputOptions[6]?.label:
                        updatedStatus = [STATUS.CANCELLED];
                        orderBy = "last_updated";
                        orderByType = "DESC";
                        break;
                      default:
                        updatedStatus = [];
                        break;
                    }
                    setStatusType(status);
                    setpageNumber(() => 1);
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      statuses: updatedStatus,
                      orderBy: orderBy,
                      orderType: orderByType,
                    }));
                  }}
                  loading={loading}
                  setLoading={setLoading}
                  onSearch={(searchQuery) => {
                    setSearchString(searchQuery);
                    getRequestsAPI(
                      requestPerPage,
                      1,
                      statusType,
                      filetrs,
                      searchQuery,
                      filterDateTime && filterDateTime.fromDate
                        ? new Date(filterDateTime.fromDate).toISOString()
                        : undefined,
                      filterDateTime && filterDateTime.toDate
                        ? new Date(filterDateTime.toDate).toISOString()
                        : undefined,
                    );
                  }}
                  searchQuery={searchString}
                  tabelContainerHeight={"401px"}
                  onCurrentPageChange={(pageNumber) => {
                    setpageNumber(pageNumber);
                    getRequestsAPI(
                      requestPerPage,
                      pageNumber,
                      statusType,
                      filetrs,
                      searchString,
                      filterDateTime && filterDateTime.fromDate
                        ? new Date(filterDateTime.fromDate).toISOString()
                        : undefined,
                      filterDateTime && filterDateTime.toDate
                        ? new Date(filterDateTime.toDate).toISOString()
                        : undefined,
                    );
                  }}
                  totalCount={requests[0]?.total_count || 0}
                  pageSize={requestPerPage}
                  activeTab={activeTab}
                  onChangeTab={(value) => setActiveTab(value)}
                />
              ) : (
                <BesRequestTable
                  pageNumber={besPageNumber}
                  requests={besRequests}
                  dateTime={filterDateTime}
                  statusType={besStatusType}
                  filters={besFiletrs}
                  onFilterChange={(filters, dateTime) => {
                    console.log("on filterchanged", filters, dateTime);
                    setBesFilters(filters);
                    if (dateTime) {
                      setFilterDateTime(dateTime);
                    }
                    setBesPageNumber(1);
                  }}
                  // onStatusFilterChanged={(status)=>{
                  //   let updatedStatus=[];
                  //   let orderBy = "date_created"
                  //   let orderByType = "DESC"
                  //   switch (status) {
                  //     case ChipInputOptions[1]?.label:
                  //        updatedStatus=[STATUS.PLACED];
                  //       break;
                  //     case ChipInputOptions[2]?.label:
                  //       updatedStatus=[STATUS.PLACED,STATUS.ACCEPTED,STATUS.RESCHEDULED,STATUS.HOLD];
                  //       orderBy = "date_created"
                  //       orderByType = "DESC"
                  //       break;
                  //     case ChipInputOptions[3]?.label:
                  //       updatedStatus=[STATUS.OUT_FOR_SERVICE,STATUS.INPROGRESS];
                  //       // orderBy = "last_updated"
                  //       orderByType = "DESC"
                  //       break;
                  //       case ChipInputOptions[4]?.label:
                  //       updatedStatus=[STATUS.COMPLETED];
                  //       // orderBy = "last_updated"
                  //       orderByType = "DESC"
                  //       break;
                  //     case ChipInputOptions[5]?.label:
                  //       updatedStatus=[STATUS.PAID];
                  //       // orderBy = "last_updated"
                  //       orderByType = "DESC"
                  //       break;
                  //     case ChipInputOptions[6]?.label:
                  //         updatedStatus=[STATUS.CANCELLED];
                  //         // orderBy = "last_updated"
                  //         orderByType = "DESC"
                  //         break;
                  //       default:
                  //         updatedStatus=[];
                  //         break;
                  //   }
                  //  setStatusType(status);
                  //  setpageNumber(()=>1)
                  //  setFilters((prevFilters)=>({...prevFilters,statuses:updatedStatus, orderBy:orderBy, orderType:orderByType}));
                  // }}
                  loading={loading}
                  setLoading={setLoading}
                  onSearch={(searchQuery) => {
                    setBesSearchString(searchQuery);
                    getBesRequestsAPI(
                      requestPerPage,
                      1,
                      besStatusType,
                      besFiletrs,
                      searchQuery,
                      filterDateTime && filterDateTime.fromDate
                        ? new Date(filterDateTime.fromDate).toISOString()
                        : undefined,
                      filterDateTime && filterDateTime.toDate
                        ? new Date(filterDateTime.toDate).toISOString()
                        : undefined,
                    );
                  }}
                  searchQuery={besSearchString}
                  tabelContainerHeight={"401px"}
                  onCurrentPageChange={(besPageNumber) => {
                    setBesPageNumber(besPageNumber);
                    getBesRequestsAPI(
                      requestPerPage,
                      besPageNumber,
                      besStatusType,
                      besFiletrs,
                      besSearchString,
                      filterDateTime && filterDateTime.fromDate
                        ? new Date(filterDateTime.fromDate).toISOString()
                        : undefined,
                      filterDateTime && filterDateTime.toDate
                        ? new Date(filterDateTime.toDate).toISOString()
                        : undefined,
                    );
                  }}
                  totalCount={besRequests[0]?.total_count || 0}
                  pageSize={requestPerPage}
                  activeTab={activeTab}
                  onChangeTab={(value) => setActiveTab(value)}
                />
              )
            ) : (
              <CalenderViewRequestTable
                user={{ ...state, pilotId, pilotName, isCalenderView: true }}
                requests={requests}
                date={selectedDate}
              />
            )}
          </div>
        </div>
      </MainContentWrapper>
    </>
  );
};

export default MyRequests;
